/**
 * DLNA API 服务
 * 用于与后端DLNA服务进行通信
 */

import {GET, POST, PUT, DELETE, reUrl} from '../../axiosconfig/axiosconfig'

export default {
  askGenre: function(params) {
    return POST(reUrl + '/agents/genre/', params)
  },
  askLyrics: function(params) {
    return POST(reUrl + '/agents/lyrics/', params)
  },
  askRegex: function(params) {
    return POST(reUrl + '/agents/regex/', params)
  },
  askSelectCandidate: function(params) {
    return POST(reUrl + '/agents/select_candidate/', params)
  },
  batchAiCandidate: function(params) {
    return POST(reUrl + '/agents/batch_ai_candidate/', params)
  },
  testConnection: function(params) {
    return POST(reUrl + '/agents/test_connection/', params)
  }
} 
